import { createSlice } from '@reduxjs/toolkit';
import { sliceName } from '../../../constants';
import { regionInitialState } from '../../initialStates';
var regionSlice = createSlice({
    name: sliceName.regionSliceName,
    initialState: regionInitialState,
    reducers: {
        setRegionConfig: function (state, action) {
            state.regionId = action.payload.regionId;
            state.regionName = action.payload.regionName;
            state.policyCheckLink = action.payload.policyCheckLink;
            state.carpoolPolicyLink = action.payload.carpoolPolicyLink;
            state.faqLink = action.payload.faqLink;
            state.showMyHubAwareness = action.payload.showMyHubAwareness;
            state.showV2UI = action.payload.showV2UI;
            state.carpoolEnabled = action.payload.carpoolEnabled;
            state.enabled = action.payload.enabled;
            state.registrationTypeList = action.payload.registrationTypeList;
            state.vehicleTypeList = action.payload.vehicleTypeList;
            state.fuelTypeList = action.payload.fuelTypeList;
        },
    },
});
export var setRegionConfig = regionSlice.actions.setRegionConfig;
export var regionReducer = regionSlice.reducer;
